import { useEffect, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { connect, useDispatch } from "react-redux";
import { Col, Input, Row, Table } from "reactstrap";
import "../../../css/settings.scss";
import Select from "react-select";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { translate } from "../../../utils/translate";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { FaSpinner } from "react-icons/fa";
import customSelectStyles from "../SelectStyle";

const AdminDashboard = (props) => {
    const dispatch = useDispatch();
    const errorObj = { lot_size: '', percentage: [], type: '' };
    const [errors, setErrors] = useState(errorObj);
    const [loading, setLoading] = useState(false);
    const [mt5GroupList, setMt5GroupList] = useState([])
    const [formData, setFormData] = useState({
        lot_size: '',
        type: 'daily',
        mt5_profit: []
    });

    useEffect(() => {
        fetch(api.get_mt5_group, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setMt5GroupList(responseJson.data)
                    let arr = [];
                    responseJson.data.map((item, i) => {
                        arr.push({ mt5_group_id: item.mt5_group_id, percentage: '' })
                    });
                    let newFormData = { ...formData };
                    newFormData.mt5_profit = arr;
                    setFormData(newFormData);
                } else {
                    if (responseJson.status === 'error' && responseJson.message === 'Token Expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log('error', responseJson.message)
                }
            }).catch(error => {
                console.error("error", error);
            });
    }, [])

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        if (fieldName === 'lot_size') {
            if (fieldValue) {
                let regexLot = /^\d+(\.\d{1,2})?$/;
                if (regexLot.test(Number(fieldValue))) {
                    newFormData[fieldName] = fieldValue;
                }
            } else {
                newFormData[fieldName] = fieldValue;
            }
        } else if (fieldName === "percentage") {
            if (fieldValue) {
                const regex = /^\d{1,3}(\.\d+)?$/;
                if (regex.test(Number(fieldValue))) {
                    const value = parseFloat(fieldValue);
                    if (value >= 0) {
                        newFormData[fieldName] = fieldValue;
                    }
                }
            } else {
                newFormData[fieldName] = fieldValue;
            }
        } else {
            newFormData[fieldName] = fieldValue;
        }

        setFormData(newFormData);
    }

    const handleProfitChange = (event, id) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };

        if (fieldValue) {
            const regex = /^\d{1,3}(\.\d+)?$/;
            if (regex.test(Number(fieldValue))) {
                const value = parseFloat(fieldValue);
                if (value >= 0) {
                    newFormData.mt5_profit.map((item, i) => {
                        if (item.mt5_group_id === id) {
                            item.percentage = fieldValue
                        }
                    })
                }
            }
        } else {
            newFormData.mt5_profit.map((item, i) => {
                if (item.mt5_group_id === id) {
                    item.percentage = fieldValue
                }
            })
        }

        setFormData(newFormData);
    }

    const generateLotRebate = () => {
        let check = true;
        let errorMsg = { ...errorObj };
        if (!formData.lot_size) {
            check = false;
            errorMsg.lot_size = "This field is required.";
        }
        if (!formData.type) {
            check = false;
            errorMsg.type = "This field is required.";
        }
        setErrors(errorMsg);
        if (check) {
            let sample = 0;
            let message = "";
            if (formData.type === 'daily') {
                sample = formData.lot_size / 4 / 5;
                message =
                    `<div class="text-grey-2">${translate(props.lang, "(NO CAPPED - based on the lot size provided)")}</div>
                <div class="text-red font-weight-600">${translate(props.lang, "Type")}: ${formData.type === 'daily' ? translate(props.lang, "Daily") : translate(props.lang, "Weekly")}</div>
                <div class="text-red font-weight-600">${translate(props.lang, "Lot Size")}: ${formData.lot_size}</div>
                <div class="text-red font-weight-600">${formData.lot_size} / 4 / 5= ${sample}</div>
                `;
            } else {
                sample = formData.lot_size / 4;
                message =
                    `<div class="text-grey-2">${translate(props.lang, "(NO CAPPED - based on the lot size provided)")}</div>
                <div class="text-red font-weight-600">${translate(props.lang, "Type")}: ${formData.type === 'daily' ? translate(props.lang, "Daily") : translate(props.lang, "Weekly")}</div>
                <div class="text-red font-weight-600">${translate(props.lang, "Lot Size")}: ${formData.lot_size}</div>
                <div class="text-red font-weight-600">${formData.lot_size} / 4 = ${sample}</div>
                `;
            }

            Swal.fire({
                title: `<div class="text-grey-2">${translate(props.lang, "Confirmation")}</div>`,
                html: message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: translate(props.lang, "Confirm"),
                cancelButtonText: translate(props.lang, "No"),
                background: '#ffffff', // Dark background color
                color: '#000', // Text color
            }).then((result) => {
                if (result.isConfirmed) {
                    let data = {
                        lot_size: parseFloat(formData.lot_size),
                        type: formData.type
                    }
                    setLoading(true);
                    fetch(api.generate_lot_rebate, {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            "Accept-Language": props.lang.toLowerCase(),
                            "Authorization": "Bearer " + props.auth.auth.access_token
                        }),
                        body: JSON.stringify(data)
                    })
                        .then(response => response.json())
                        .then(responseJson => {
                            setLoading(false);
                            if (responseJson.status === 'success') {
                                swal(translate(props.lang, "Success"), responseJson.message, { icon: "success" });
                                setFormData({
                                    lot_size: '',
                                    type: 'daily',
                                    mt5_profit: [],
                                })
                            } else {
                                setLoading(false);
                                if (responseJson.status === 'error' && responseJson.message === 'Token Expired') {
                                    dispatch(logout(props.history, 'login'));
                                }
                                if (typeof responseJson.data.error === 'object') {
                                    let apiErrorMsg = { ...errorObj };
                                    let popupMessage = [];
                                    Object.keys(responseJson.data.error).map((key, i) => {
                                        apiErrorMsg[key] = responseJson.data.error[key];
                                        popupMessage.push(responseJson.data.error[key])
                                    })
                                    setErrors(apiErrorMsg);
                                    swal(translate(props.lang, "Error"), popupMessage.join("\n"), "error");
                                } else {
                                    swal(translate(props.lang, "Error"), responseJson.message, "error");
                                }
                            }
                        });
                }
            });
        }
    }

    const generateProfit = () => {
        let check = true;
        let errorMsg = { ...errorObj };
        let msg = []
        mt5GroupList.map((item, i) => {
            let filter = formData.mt5_profit.filter(data => data.mt5_group_id === item.mt5_group_id);
            if (filter[0].percentage === "") {
                msg.push("This field is required.")
                check = false;
            } else {
                msg.push("")
            }
        })

        errorMsg.percentage = msg
        setErrors(errorMsg);
        if (check) {
            let obj = {}
            formData.mt5_profit.map((item, i) => {
                obj[item.mt5_group_id] = parseFloat(item.percentage);
            })

            let sample = 1000 * 1 / 100;
            let message =
                `<div class="text-grey-2">${translate(props.lang, "This profit did not deduct the 20% for company.")}</div>
            <div class="text-grey-2">${translate(props.lang, "eg: mt5 account")} 1000 </div>
            <div class="text-red font-weight-600">${translate(props.lang, "Profit")}: 1%</div>
            <div class="text-red font-weight-600">1000 * 1 / 100 = ${sample}</div>
            `;
            Swal.fire({
                title: `<div class="text-grey-2">${translate(props.lang, "Confirmation")}</div>`,
                html: message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: translate(props.lang, "Confirm"),
                cancelButtonText: translate(props.lang, "No"),
                background: '#ffffff', // Dark background color
                color: '#000', // Text color
            }).then((result) => {
                if (result.isConfirmed) {
                    let data = {
                        percentage: obj
                    }
                    setLoading(true);
                    fetch(api.generate_profit, {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            "Accept-Language": props.lang.toLowerCase(),
                            "Authorization": "Bearer " + props.auth.auth.access_token
                        }),
                        body: JSON.stringify(data)
                    })
                        .then(response => response.json())
                        .then(responseJson => {
                            setLoading(false);
                            if (responseJson.status === 'success') {
                                swal(translate(props.lang, "Success"), responseJson.message, { icon: "success" });
                                setFormData({
                                    lot_size: '',
                                    type: 'daily',
                                    mt5_profit: [],
                                })
                            } else {
                                setLoading(false);
                                if (responseJson.status === 'error' && responseJson.message === 'Token Expired') {
                                    dispatch(logout(props.history, 'login'));
                                }
                                if (typeof responseJson.data.error === 'object') {
                                    let apiErrorMsg = { ...errorObj };
                                    let popupMessage = [];
                                    Object.keys(responseJson.data.error).map((key, i) => {
                                        apiErrorMsg[key] = responseJson.data.error[key];
                                        popupMessage.push(responseJson.data.error[key])
                                    })
                                    setErrors(apiErrorMsg);
                                    swal(translate(props.lang, "Error"), popupMessage.join("\n"), "error");
                                } else {
                                    swal(translate(props.lang, "Error"), responseJson.message, "error");
                                }
                            }
                        });
                }
            });
        }
    }

    const changeTab = (type) => {
        let newFormData = { ...formData };
        newFormData.type = type;
        setFormData(newFormData)
    }

    const handleOptionEditSelect = async (e, type) => {
        const { value } = e;
        const newFormData = { ...formData };
        newFormData[type] = value;
        setFormData(newFormData);
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer">
                            <div className="px-md-3 py-md-3 px-2 py-4">
                                <Row className="align-items-center border-bottom-light px-0 mx-0 py-3">
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <span className="font-weight-600 font-20 text-black">{translate(props.lang, "Run Lot Rebate Bonus")}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <div className='mb-2 text-start mt-4 ps-2'>
                                            <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Type")} </span>
                                        </div>
                                        <div className={`profit-tab-container w-50 d-flex justify-content-start ${errors.type ? 'errorBorder' : ''}`}>
                                            <div className={`tab-item w-50 h-100 text-center px-4 py-3 ${formData.type === 'daily' ? 'tabActive' : "tabInactive"}`} onClick={() => changeTab('daily')}>
                                                <span className="font-weight-600 font-16 text-capitalize">{translate(props.lang, "Daily")}</span>
                                            </div>
                                            <div className={`tab-item w-50 h-100 text-center px-4 py-3 ${formData.type === 'weekly' ? 'tabActive' : "tabInactive"}`} onClick={() => changeTab('weekly')}>
                                                <span className="font-weight-600 font-16 text-capitalize">{translate(props.lang, "Weekly")}</span>
                                            </div>
                                        </div>
                                        <div className="mt-1">
                                            <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.type)}</span>
                                        </div>

                                        <div className='mb-2 text-start mt-4 ps-2'>
                                            <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Lot Size")} </span>
                                        </div>
                                        <div className={`groupLabel-input ${errors.lot_size ? 'errorBorder' : ''} mt-2 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    name="lot_size"
                                                    placeholder={translate(props.lang, "Enter Lot Size")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    autoComplete="off"
                                                    value={formData.lot_size}
                                                    onChange={(e) => handleAddFormChange(e)}
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-1">
                                            <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.lot_size)}</span>
                                        </div>
                                    </Col>
                                    <Col lg={3} md={3} sm={12} xs={12}>
                                        <button className="primary-btn w-100 px-5 py-2 text-center" onClick={() => generateLotRebate()} disabled={loading}>
                                            {loading ? <FaSpinner className="fa-spin" color="#fff" /> : (
                                                <div className='d-flex w-100 justify-content-center align-items-center'>
                                                    <span className={`font-weight-600 font-18 line-height-30 text-white`}>{translate(props.lang, "Run")}</span>
                                                </div>
                                            )}
                                        </button>
                                    </Col>
                                </Row>
                                <Row className="align-items-center px-0 mx-0 py-3">
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <span className="font-weight-600 font-20 text-black">{translate(props.lang, "Run MT5 Profit")}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <Table responsive className="w-100 table-list text-center position-relative">
                                            <thead>
                                                <tr>
                                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Group")}</th>
                                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Percentage")}%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {mt5GroupList.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`}>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.group_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>
                                                            <div className={`groupLabel-input py-1 py-md-0 ${errors.percentage.length > 0 ? errors.percentage[i] ? 'errorBorder' : '' : ''}`}>
                                                                <div className="input-group">
                                                                    <Input
                                                                        type="text"
                                                                        name="percentage"
                                                                        placeholder={translate(props.lang, "Enter Profit") + " (%) "}
                                                                        className={`input-transparent form-control px-3`}
                                                                        autoComplete="off"
                                                                        value={formData.mt5_profit.filter(data => data.mt5_group_id === item.mt5_group_id).length > 0 ? formData.mt5_profit.filter(data => data.mt5_group_id === item.mt5_group_id)[0].percentage : ''}
                                                                        onChange={(e) => handleProfitChange(e, item.mt5_group_id)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="mt-1 text-start">
                                                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.percentage.length > 0 ? errors.percentage[i] : '')}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        {/* <div className='mb-2 text-start mt-4 ps-2'>
                                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "MT5 Group")} </span>
                                                    </div> */}
                                        {/* <div className={`input-group-select mt-1 mb-1 ${errors.mt5_group_id ? 'errorBorder' : ''}`}>
                                                        <Select
                                                            options={
                                                                mt5GroupList.length > 0 ? mt5GroupList.map((item, i) => ({ key: i, value: item.mt5_group_id, label: item.group_name })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                            }
                                                            placeholder={translate(props.lang, "Select MT5 Group")}
                                                            className="input-transparent w-100 text-capitalize"
                                                            styles={customSelectStyles}
                                                            isSearchable={false}
                                                            value={mt5GroupList.filter(option => option.mt5_group_id === formData.mt5_group_id).length > 0 ? mt5GroupList.filter(option => option.mt5_group_id === formData.mt5_group_id).map((item, i) => ({ key: i, value: item.mt5_group_id, label: item.group_name })) : null}
                                                            name="type"
                                                            onChange={(e) => handleOptionEditSelect(e, "mt5_group_id")}
                                                        />
                                                    </div>
                                                    <div className="mt-1">
                                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.type)}</span>
                                                    </div> */}

                                        {/* <div className='mb-2 text-start mt-4 ps-2'>
                                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Profit")} %</span>
                                                    </div>
                                                    <div className={`input-group-select py-1 py-md-0 ${errors.percentage ? 'errorBorder' : ''}`}>
                                                        <Input
                                                            type="text"
                                                            name="percentage"
                                                            placeholder={translate(props.lang, "Enter Profit")}
                                                            className={`input-transparent px-3`}
                                                            autoComplete="off"
                                                            value={formData.percentage}
                                                            onChange={(e) => handleAddFormChange(e)}
                                                        />
                                                    </div>
                                                    <div className="mt-1">
                                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.percentage)}</span>
                                                    </div> */}
                                    </Col>
                                    <Col lg={3} md={3} sm={12} xs={12}>
                                        <button className="primary-btn px-5 py-2 w-100 text-center" onClick={() => generateProfit()} disabled={loading}>
                                            {loading ? <FaSpinner className="fa-spin" color="#fff"/> : (
                                                <div className='d-flex w-100 justify-content-center align-items-center'>
                                                    <span className={`font-weight-600 font-18 line-height-30 text-white`}>{translate(props.lang, "Run")}</span>
                                                </div>
                                            )}
                                        </button>

                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(AdminDashboard);